import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';

@Injectable()
export class HaCaselistServiceService {

  constructor(private http: HttpClient) { }
  getCaseListData() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Case/getCaseListData');
  }

  getPatientByCase(id: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Case/getPatientsInCase?id='+ id);
  }

  getCodesByCase(id: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Case/getCaseCodes?id='+ id);
  }
}
